import React, { useCallback, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from 'BridgReusables/Button';
import { toTitleCase } from 'lib/Formatting';

import * as styles from './ConfirmationModal.scss';

const ConfirmationModal = (props) => {
  const {
    showModal,
    closeModal,
    isBusy,
    subject = 'subject',
    verb = 'verb',
    title,
    question,
    confirmationString,
    yesLabel,
    yesColor,
    yesFn,
    noLabel = 'Cancel',
    noColor,
    noFn = closeModal,
    disabled,
  } = props;

  const [confirmationInputVal, setConfirmationInputVal] = useState('');
  const [confirmationInputMatches, setConfirmationInputMatches] = useState(false);

  const onChange = useCallback((e) => {
    const { value } = e.target;
    setConfirmationInputVal(value);
    setConfirmationInputMatches(value === confirmationString);
  }, [confirmationString]);

  return (
    <Dialog
      open={showModal}
      onClose={closeModal}
      maxWidth="xs"
      fullWidth
      className={styles.confirmationModal}
    >
      <DialogTitle>{title ?? toTitleCase(`${verb} ${subject}`, true)}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div" sx={{ mb: 2 }}>
          {question ?? <div>Are you sure you want to {verb.toLowerCase()} <b>{subject}</b>?</div>}
        </DialogContentText>
        {confirmationString && <TextField
          value={confirmationInputVal}
          onChange={onChange}
          error={!!confirmationInputVal && !confirmationInputMatches}
          variant="outlined"
          size="small"
          label={`Type '${confirmationString}' to confirm`}
          fullWidth
          autoFocus={!!confirmationString}
        />}
      </DialogContent>
      <DialogActions sx={{ pt: 0, pb: 3, px: 3 }}>
        <Button onClick={noFn} variant="outlined" color={noColor}>{noLabel}</Button>
        <Button
          onClick={yesFn}
          color={yesColor}
          loading={isBusy}
          disabled={disabled || (confirmationString && !confirmationInputMatches)}
          autoFocus={!confirmationString}
        >
          {yesLabel ?? toTitleCase(verb)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
